import React, { useEffect } from 'react'
import { sessionStore } from '@store/session-store'
import { configureScope, configureGalio } from '@library'
import { configAegis } from '../../library/rum'

/**
 * 配置上报信息等， 写成组件的原因是userInfo必须在Provider里面才能获取到
 * @constructor
 */
export const ConfigInfo: React.FC<React.PropsWithChildren<{}>> = () => {
  // 使用 session-store 获取 userInfo
  const userInfo = sessionStore(s => s.userInfo)

  // 配置性能监控信息
  useEffect(() => configAegis(userInfo), [userInfo])

  // 配置sentry信息
  useEffect(() => configureScope(userInfo), [userInfo])

  // 配置伽利略信息
  useEffect(() => configureGalio(userInfo), [userInfo])

  return null
}
